import BotResponseTreeNode from './BotResponseTreeNode';
import EnvironmentVariable from './EnvironmentVariable';
import OutputVariableMapping from './OutputVariableMapping';

const generateMappingId = (): string =>
  `mapping-${Date.now()}-${Math.random().toString(36).substring(2, 11)}`;

class CodeBlockTreeNode {
  code: string;

  environmentVariables: EnvironmentVariable[];

  outputMappings: OutputVariableMapping[];

  nextStep: BotResponseTreeNode | null;

  nextStepOnError: BotResponseTreeNode | null;

  constructor(
    code: string,
    environmentVariables: EnvironmentVariable[],
    outputMappings: OutputVariableMapping[],
    nextStep: BotResponseTreeNode | null,
    nextStepOnError: BotResponseTreeNode | null = null
  ) {
    this.code = code;
    this.environmentVariables = environmentVariables;
    this.outputMappings = outputMappings.map((m) => ({
      ...m,
      id: m.id || generateMappingId()
    }));
    this.nextStep = nextStep;
    this.nextStepOnError = nextStepOnError;
  }
}

export default CodeBlockTreeNode;
